import { FileInputProps } from "../../../store/types/misc";

const FileInputCV: React.FC<FileInputProps> = ({
  label,
  name,
  status,
  onChange,
  value,
}) => (
  <div className="mb-3 font-abel flex gap-4 items-center">
    <label className="text-[#99991E1E1E99] text-[15px">{label}</label>
    <input
      type="file"
      name={name}
      // value={value}
      accept=".pdf"
      onChange={onChange}
      className="hover:cursor-pointer"
    />
    {status && <div className="text-red-500 text-xs">{status}</div>}
  </div>
);

export default FileInputCV;
